export const AUTOPAY_SIGN_UP = 'AUTOPAY_SIGN_UP';
